import { Color } from '@diritto/common/style/color';
import styled from '@emotion/styled';
import { IconButton } from 'ui-components/common/IconButton';
import { Link } from 'ui-components/common/Link';
import { NotiIcon } from 'icons/NotiIcon';
import { SearchIcon } from 'icons/SearchIcon';

export const SearchLinkButton = () => (
  <StyledIconButton>
    <Link href="/search">
      <SearchIcon />
    </Link>
  </StyledIconButton>
);

export const InboxLinkButton = ({ unreadCount }: { unreadCount: number }) => (
  <StyledIconButton>
    {unreadCount > 0 && <StyledInboxUnreadCount>{unreadCount < 100 ? unreadCount : '99+'}</StyledInboxUnreadCount>}
    <Link href="/inbox">
      <NotiIcon fill />
    </Link>
  </StyledIconButton>
);

const StyledIconButton = styled(IconButton)`
  width: 24px;
  height: 24px;
  position: relative;

  & > a {
    width: 100%;
    height: 100%;
  }
`;

const StyledInboxUnreadCount = styled.p`
  padding: 3px 4px;
  background-color: ${Color.Red500};
  border-radius: 14px;
  color: ${Color.White};
  position: absolute;
  font-size: 10px;
  line-height: 10px;
  top: 3px;
  right: 4px;
  transform: translate(50%, -50%);
`;
